export const UPDATE_COMPONENT_STATE =
  'reports/components/UPDATE_COMPONENT_STATE'
